import classNames from "classnames";

import { DComponent } from "../../../DComponent";
import Env from "../../../../environments";
import { defer } from "../../../../utils/script";
import { devLog } from "../../../../utils/log";

export default class AuthGoogle extends DComponent {
  constructor({
    parent,
    id,
    onSubmit = () => { },
    onError = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("AuthGoogle"),
    });
    this.onSubmit = onSubmit;
    this.onError = onError;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "AuthGoogle");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  initGoogle() {
    window.google.accounts.id.initialize({
      client_id: Env.DUTY_CAST_GOOGLE_CLIENT_ID,
      ux_mode: "popup",
      callback: (data) => this.callback(data)
    });
    window.google.accounts.id.disableAutoSelect();
    window.google.accounts.id.renderButton($(".btn-google", this.element)[0], {
      type: "icon",
      // width: "200",
    });
  }

  show() {
    defer(() => window.google?.accounts?.id, () => {
      this.initGoogle();
      $(".btn-google div[role=button]", this.element).click();
    });
  }

  callback(response) {
    devLog(response);
    if (response?.credential) {
      typeof this.onSubmit === "function" && this.onSubmit(response.credential);
    } else {
      typeof this.onError === "function" && this.onError(response);
    }
  }
}